/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const HighSoundIndicatorIcon = ({
  width = 5,
  height = 16,
  color = '#fff',
  ...props
}: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 5 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.80364 0.461524C0.983461 0.251955 1.29912 0.22784 1.50869 0.407661C3.64521 2.2409 5 4.9624 5 7.99978C5 11.0372 3.64521 13.7587 1.50869 15.5919C1.29912 15.7717 0.983461 15.7476 0.80364 15.538C0.623819 15.3285 0.647935 15.0128 0.857504 14.833C2.78206 13.1816 4 10.7332 4 7.99978C4 5.26636 2.78206 2.81794 0.857504 1.16658C0.647935 0.986755 0.623819 0.671092 0.80364 0.461524Z"
      fill={color}
    />
  </svg>
);

export default HighSoundIndicatorIcon;
